import React from 'react'

const Tr = (props) => {

    const settle = props.settle;

    return (
    <>
        <tr>
            <td>{settle.user_id}</td>
            <td>{settle.email}</td>
            <td>{settle.last_name}{settle.first_name}</td>
            <td>{settle.point}</td>
            <td>{settle.payment_amount}</td>
            <td>{(new Date(settle.created_at)).toLocaleString()}</td>
            <td>{settle.id}</td>
            <td>{settle.fincode_token}</td>
        </tr>
    </>
    )
}

export default Tr